import React, { useState,useEffect } from "react";
import { Link } from "react-router-dom"; // Import Link from react-router-dom
import { motion } from "framer-motion"; // Import motion from framer-motion
import { AnimatePresence } from "framer-motion";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState({ services: false, products: false });

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  // Staggering animation variants for the links
  const linkVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: (index) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: index * 0.3, 
        type: "spring",
        stiffness: 100,
      },
    }),
    exit:(index)=>({
      opacity:0,
      y:20,
      transition: {
        delay: index*0.5,
        type:"spring",
        stiffness:100,
      }
    })
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleDropdown = (key) => {
    setIsDropdownOpen((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const dropdownVariants = {
    hidden: { opacity: 0, y: -20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { type: "spring", stiffness: 120, duration:0.5 },
    },
    exit: { opacity: 0, y: -20, transition: { damping:20 } },
  };

  // const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  // const handleCloseMenu = () => {
  //   setIsOpen(false);
  // };

  useEffect(() => {
 
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true); 
      } else {
        setIsScrolled(false); 
      }
    };
    window.addEventListener("scroll", handleScroll);
  }, []);
  const splitText = (text) => text.split("");

  const letterVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: 
      (index) => ({
        opacity: 1,
        y: 0,
        transition: {
          delay: index * 0.05, // Staggered delay based on index
          type: "spring",
          stiffness: 100,
        },
    }),
  };

  // Staggered animation for the letters
  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 1, // Delay between letters
      },
    },
  };


  return (
    <div className="relative">
      {/* Menu Button (Visible on all screen sizes) */}

      <nav
      className={`fixed w-full z-50 py-2 transition-colors duration-1000 ease-in-out ${
        isScrolled ? "bg-white text-white shadow-lg" : "bg-white"
      }`}
    >
      <div className=" mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center">
            <Link to="/" className={`title no-underline transition duration-700 d-flex text-2xl md:text-5xl font-serif font-bold ${isScrolled ? "text-yellow-500" : "text-yellow-500"}`}>
              <img src="./logo.png" className="h-32 w-32 mt-24 inline"/> 
            </Link>
          </div>
          <div className="relative group inline-block">
            <button
              onClick={toggleMenu}
              className="text-gray-900 focus:outline-none px-4 py-2 text-black rounded-md focus:outline-none"
            >

              <svg
                className={`h-6 w-6 transform transition-transform duration-300 ${
                  isOpen ? "rotate-90" : "rotate-0"
                } ${isScrolled ? "text-yellow-500" : "text-yellow-500"}`}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                  d={
                    isOpen
                      ? "M6 18L18 6M6 6l12 12"
                      : "M4 6h16M4 12h16M4 18h16"
                  }
                />
              </svg>
            </button>
          </div>

          
          </div>
        </div>
      </nav>
      <div
        className={`fixed top-24 right-0 w-full md:w-1/4 h-3/4  bg-white text-white z-20 transition-all duration-1000 ease-in-out ${
          isOpen ? "translate-x-100 scale-100 " : "translate-x-full scale-100"
        }`}
      >
        

        {/* Menu Layout for Larger Screens */}
        <div className="md:flex px-12 h-full  md:justify-center md:items-center px-4 pt-10 md:pt-2 space-x-8">
          {/* Menu Links Section */}
          <div className="lg:w-1/2 flex  justify-center items-center mx-auto">
          <span className="absolute  text-center  md:left-5  inset-0 text-yellow-600 top-1/2 text-7xl font-bold opacity-20 font-serif -z-10 select-none">
          MENU
        </span>

        <motion.ul className="space-y-6 text-black" initial="hidden" animate="visible">
              {["Home", "About", "Services","Projects","Reviews","Terms","Contact"].map((link, index) => (
                <motion.li
                  key={link}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.2, type: "spring", stiffness: 100 }}
                  className="text-lg text-center group"
                >
                  <Link
                    to={link === "Home" ? "/" : `/${link.toLowerCase()}`}
                    onClick={toggleMenu}
                    className="py-2 font-serif relative  duration-700"
                  >
<span className="relative">{link === "Terms" ? "Terms & Conditions" : `${link==="About" ? "About Us" : `${link==="Projects"?"Our Projects":`${link==="Services"?"Our Services":`${link==="Contact"?"Contact Us":`${link==="Reviews"?"Customer Testimonials":`${link==="Team"?"Our Team":`${link}`}`}`}`}`}`}`}</span>
<div className="absolute left-0 bottom-0 w-0 h-1 bg-gradient-to-r from-yellow-500 to-yellow-900 rounded group-hover:w-full transition-all duration-500"></div>
                  </Link>
                </motion.li>
              ))}
                {/* <motion.li className="text-lg text-center group"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 1.2, type: "spring", stiffness: 100 }}
                >
                    <a href="#CustomersOpinion" className="py-2 font-serif relative group duration-700" onClick={toggleMenu}><span className="relative">Customer Testimonials</span></a>
                    <div className="absolute left-0 w-0 h-1 bg-gradient-to-r from-yellow-500 to-yellow-900 rounded group-hover:w-full transition-all duration-500"></div>
                </motion.li> */}
            </motion.ul>
          </div>
        </div>

        </div>
      </div>

  );
};

export default Navbar;
